﻿$.fn.dxCtrlDefineRepAuto = function custom_dxCtrlDefineRepAuto(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldefinerepauto dx-ctrl");
        this.createInstance(new cdxCtrlDefineRepAuto(this, option));
    }
    return this;
}

window.cdxCtrlDefineRepAuto = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivLoad = null
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        container.css("height", "100%")
        container.css("margin", "5px 0")

        switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
            case "compte_email":
                $("<div class='dx-field-item-label-text' style='font-size:80%;padding-bottom:5px;'>Définir la réponse automatique pour l'adresse email</div>").appendTo(container)
                break;
            case "utilisateur":
                $("<div class='dx-field-item-label-text' style='font-size:80%;padding-bottom:5px;'>Définir la réponse automatique pour toutes les adresses emails de l'utilisateur</div>").appendTo(container)
                break;
            case "compte_client":
                $("<div class='dx-field-item-label-text' style='font-size:80%;padding-bottom:5px;'>Définir la réponse automatique pour toutes les adresses emails de tous les utilisateurs</div>").appendTo(container)
                break;
        }

        var $TableRepAuto = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($TableRepAuto)
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlSwitch({
            value: (option.data.repauto_actif == "1"),
            switchedOnText: "",
            switchedOffText: "",
            onValueChanged: function (e) {
                if (e.value) { dxEmailData.element().slideDown(100) }
                else { dxEmailData.element().slideUp(100) }
                dxRangeDate.option("disabled", !e.value)
                if (!e.value) {
                    option.data.repauto_debut = null
                    option.data.repauto_fin = null
                    dxRangeDate.option("value", [null, null])
                }
                option.data.repauto_actif = ((e.value) ? "1" : "0")
                option.bddCtrl.getObjet(option.data).mSaveChamp("repauto_actif");
            }
        })
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var dxRangeDate = $("<div/>").appendTo($Td).dxDateRangeBox({
            disabled: (option.data.repauto_actif == "0"),
            value: [option.data.repauto_debut, option.data.repauto_fin],
            onValueChanged: function (e) {
                option.data.repauto_debut = null
                option.data.repauto_fin = null
                if (e.value[0] != null) option.data.repauto_debut = new Date(e.value[0].getFullYear(), e.value[0].getMonth(), e.value[0].getDate(), 0, 0, 0)
                if (e.value[1] != null) option.data.repauto_fin = new Date(e.value[1].getFullYear(), e.value[1].getMonth(), e.value[1].getDate(), 23, 59, 59)
                option.bddCtrl.getObjet(option.data).mSave();
            }
        }).dxDateRangeBox("instance");

        var dxEmailData = $("<div style='margin-top:10px;'/>").appendTo(container).dxCtrlEmailData({
            bddCtrl: option.bddCtrl,
            value: option.data.repauto_signature,
            txtTooltip: "Signature email réponse automatique",
            tooltipModif: "Modifier la réponse auto",
            tooltipSupp: "Supprimer la réponse auto",
            tooltipNew: "Créer une nouvelle réponse auto",
            titlePopupEmail: "Réponse automatique",
            rempliTxtLib: function (contentElement, value) {
                var txtLib = ""
                if (value == null || value.length == 0) {
                    txtLib = "<div style='color:" + theme.toastWarning + ";font-size:16px;'>Aucune signature pour votre réponse automatique</div><div style='opacity:0.4;font-size:80%;'><i>(Le texte de votre message sera un message d'absence simple)</i></div></div>"
                } else {
                    txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>réponse automatique définie</div>"
                }
                contentElement.html(txtLib)
            },
            onValueChanged: function (dataSignature) {
                option.data.repauto_signature = dataSignature;
                option.bddCtrl.getObjet(option.data).mSaveChamp("repauto_signature");
            }
        }).dxCtrlEmailData("instance")

        if (option.data.repauto_actif == "0") dxEmailData.element().hide()
    }

    this.element = function () { return container }

    mConstruit();
}